import { editorialPicks } from "@/mocks/homeData";

export default function EditorialPickSection() {
  return (
    <section id="features" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div className="flex items-center gap-2">
            <i className="ri-article-line text-primary-500 text-lg"></i>
            <h2 className="text-lg md:text-xl font-bold text-foreground-950">
              編集部おすすめ特集
            </h2>
          </div>
          <a
            href="#"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1"
          >
            もっと見る
            <i className="ri-arrow-right-s-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {editorialPicks.map((pick) => (
            <a
              key={pick.id}
              href="#"
              className="group relative rounded-xl overflow-hidden hover:shadow-md transition-all"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={pick.image}
                  alt={pick.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-sm md:text-base font-bold text-white mb-1">
                  {pick.title}
                </h3>
                <p className="text-xs text-white/80">{pick.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}